import React from 'react';
import {
  Label,
  TextField,
  Text,
  Stack,
  Icon,
  DefaultButton,
  DetailsList,
  DetailsListLayoutMode,
  SelectionMode,
} from '@fluentui/react';

import { Toggle } from '@fluentui/react';
import ComboBoxInput from '../../../lib/FormValidator/Form/ComboBoxInput';
import CustomInputIfc from '../../../lib/FormValidator/Form/CustomInputIfc';
import InputField from '../../../lib/FormValidator/Form/InputField';
import MessageCourier from '../../../lib/MessageCourier';
import SystemClient from '../../../system/SystemClient';
import RegistroEntrenadorForm from '../../RegistroEntrenador/RegistroEntrenadorForm';
import { useCustomInput } from '../../../common/custom-hooks/useCustomInput';
import useForceUpdate from '../../../common/custom-hooks/useForceUpdate';
import { AppContext } from '../../../AppInRouterContext';
import RegistroEntrenadorAntecedenteForm from '../../RegistroEntrenadorAntecedente/RegistroEntrenadorAntecedenteForm';

interface IAntecedentes {
  form: RegistroEntrenadorForm;
  onBlurCustomInput: (customInput: CustomInputIfc) => void;
  system: SystemClient;
  courier: MessageCourier;
  appContext: AppContext;
  onNextEnable: (valid: boolean) => void;
}

export const Antecedentes = ({ form, onBlurCustomInput, system, courier, appContext, onNextEnable}: IAntecedentes) => {

  const [showAddAnother, setShowAddAnother] = React.useState(false);

  const [antecedenteForm, setAntecedenteForm] = React.useState<RegistroEntrenadorAntecedenteForm>(
    RegistroEntrenadorAntecedenteForm.initialize()
  );

  const forceUpdate = useForceUpdate();
  const [formIsValid, setFormIsValid] = React.useState(false);

  const antecedentesList = useCustomInput(() => form.getAntecedenteEntrenadorListInput(), [form]);
  const [toggleChecked, setToggleChecked] = React.useState(false);

  React.useEffect(() => {
    if (antecedentesList.getValue().length > 0) {
      setShowAddAnother(true);
      onNextEnable(true);
    }
  }, []);

  const addAntecedente = () => {
    const antecedentes = [...antecedentesList.getValue()];
    antecedentes.push(antecedenteForm.toRegistroEntrenadorAntecedente());
    antecedentesList.setValue(antecedentes);
    setAntecedenteForm(RegistroEntrenadorAntecedenteForm.initialize());
    onBlurCustomInput(antecedentesList);
    setShowAddAnother(true);
    onNextEnable(true);
  };

  const onBlurTitulos = (customInput: CustomInputIfc) => {
    if (antecedenteForm) {
      const isValid = antecedenteForm.getIdInput().getValue()
        ? !antecedenteForm.hasErrors()
        : antecedenteForm?.isValid();
      setFormIsValid(isValid);
      forceUpdate();
      return isValid;
    }
    return false;
  };

  // React.useEffect(() => {
  //   console.log(antecedentesList.getValue());
  // }, [antecedentesList]);

  const onRenderIndexColumn = (item?: any, index?: number, column?: any) => {
    return <span>{index !== undefined ? index + 1 : ''}.</span>;
  };

  const formatTipoForList = (tipo: string) => {
    switch (tipo) {
      case 'PyC':
        return 'Pedagógicos y culturales';
      case 'H':
        return 'Handball';
      case 'O':
        return 'Otros';
    }
  }

  const columns = [
    {
      key: 'index',
      name: '',
      fieldName: 'index',
      minWidth: 3,
      maxWidth: 3,
      onRender: onRenderIndexColumn,
    },
    {
      key: 'detalle',
      name: 'Detalle',
      fieldName: 'detalle',
      minWidth: 140,
      maxWidth: 140,
      isMultiline: true,
    },
    {
      key: 'tipo',
      name: 'Tipo',
      fieldName: 'tipo',
      minWidth: 90,
      maxWidth: 90,
      isMultiline: true,
      onRender: (item: any) => {return <span>{formatTipoForList(item.tipo)}</span>},
    },
    {
      key: 'delete',
      name: '',
      fieldName: 'delete',
      minWidth: 10,
      maxWidth: 10,
      onRender: (item: RegistroEntrenadorAntecedenteForm) => (
        <Icon iconName="Trash" onClick={() => handleDelete(item)} styles={iconStyles} />
      ),
    },
  ];

  const handleDelete = (antecedenteDelete: RegistroEntrenadorAntecedenteForm) => {
    antecedentesList.setValue(
      antecedentesList
        .getValue()
        .filter((antecedente: RegistroEntrenadorAntecedenteForm) => antecedente !== antecedenteDelete)
    );
    onBlurCustomInput(antecedentesList);
  };

  const iconStyles = {
    root: {
      cursor: 'pointer',
      fontSize: '20px',
    },
  };

  const AntecedentesTipoOptions = [
    { key: 'PyC', text: 'Pedagógicos y culturales' },
    { key: 'H', text: 'Handball' },
    { key: 'O', text: 'Otros' },
  ];

  const isNumber = (str: string) => {
    return /^[0-9]+$/.test(str);
  }

  const disableAdd = () => {
    const ret = !antecedenteForm.getDetalleInput().getValue() || !antecedenteForm.getTipoInput().getValue();
    onNextEnable(ret);
    return ret;
  }

  const disableCancel = () => {
    const ret = !antecedenteForm.getDetalleInput().getValue() && !antecedenteForm.getTipoInput().getValue();
    onNextEnable(ret);
    return ret;
  }

  const cancelAdd = () => {
    setAntecedenteForm(RegistroEntrenadorAntecedenteForm.initialize());
  }

  const getAntecedenteCaption = () => {
    console.log('tipo: ', antecedenteForm.getTipoInput().getValue());
    switch(antecedenteForm.getTipoInput().getValue()) {
      case 'PyC':
        return 'Publicaciones, Libros y Artículos, Congresos, Jurados, Idiomas, Etc.';
      case 'H':
        return 'Actuaciones deportivas como jugador/a, como árbitro, en selecciones, no evaluadas en otros apartados.';
      case 'O':
        return 'Cargos Directivos en el Handball.';
      default:
        return '';
    }
  }

  return (
    <div>
      <div className="ms-Grid" dir="ltr">
        <Text
          className="mb-1"
          variant="small"
          styles={{ root: { textAlign: 'center', color: '#666', display: 'block' } }}
        >
          {getAntecedenteCaption()}
        </Text>

        {showAddAnother ? (
          <div className="ms-Grid-row mt-2">
            <div className="ms-Grid-col ms-sm12 form-item">
              <DefaultButton
                onClick={() => setShowAddAnother(false)}
                text="Agregar otro"
                styles={{ root: { width: '100%' } }}
                primary
              />
            </div>
          </div>
        ) : (
          <>
            <div className="ms-Grid-row mt-2">
              <div className="ms-Grid-col ms-sm12 form-item">
                <InputField
                  input={antecedenteForm.getDetalleInput()}
                  label={'Detalle del antecedente'}
                  onBlur={onBlurCustomInput}
                />
              </div>
            </div>

            <div className="ms-Grid-row mt-2">
              <div className="ms-Grid-col ms-sm12 form-item">
                <ComboBoxInput
                  input={antecedenteForm.getTipoInput()}
                  label={'Tipo'}
                  onBlur={onBlurCustomInput}
                  options={AntecedentesTipoOptions}
                />
              </div>
            </div>

            <div className="ms-Grid-row mt-2">
              <div className="ms-Grid-col ms-sm6 form-item" style={{ display: 'flex', flexDirection: 'row' }}>
                <Label className="mr-2" style={{ padding: 0 }}>
                  Comprobable
                </Label>
                 <Toggle
                  offText="No comprobable"
                  onText="Comprobable"
                  checked={toggleChecked}
                  onChange={() => {
                    setToggleChecked((prev) => !prev);
                  }}
                />
              </div>
            </div>

            <div className="ms-Grid-row mt-2">
              <div className="ms-Grid-col ms-sm12 form-item">
                <DefaultButton
                  disabled={disableAdd()}
                  onClick={addAntecedente}
                  text="Agregar"
                  styles={{ root: { width: '100%' } }}
                  primary
                />
                 <DefaultButton 
                  disabled={disableCancel()} 
                  onClick={cancelAdd} 
                  text="Cancelar"
                  styles={{ root: { width: '100%', marginTop: 8} }} />
              </div>
            </div>
          </>
        )}

        {/* {antecedentesList.getValue().map((titulo: RegistroEntrenadorTitulo, index: number) => ( */}
        <div className="ms-Grid-row mt-2">
          <div className="ms-Grid-col ms-sm12 form-item">
            <DetailsList
              items={antecedentesList.getValue()}
              columns={columns}
              layoutMode={DetailsListLayoutMode.fixedColumns}
              selectionMode={SelectionMode.none}
            />
          </div>
        </div>
        {/* ))} */}
      </div>
    </div>
  );
};
